import { useTranslation } from "react-i18next";
import UserSettingsService from "src/services/userSettingsService";
import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

import { useDrawerContext } from "./Drawer";
import { drawerCloseWidth, drawerOpenWidth } from "./Drawer.styles";

const useStyles = makeStyles()((theme: Theme) => ({
    toggleButton: {
        backgroundColor: theme.palette.emteria.primary,
        height: 20,
        width: 20,
        maxWidth: 20,
        position: "fixed",
        top: theme.spacing(4),
        left: theme.spacing(-2),
        borderRadius: "50%",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "none",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        zIndex: 20,
    },
    toggleIcon: { color: theme.palette.emteria.text.inverse, fontSize: 12 },
    hide: { transform: `translateX(${drawerCloseWidth}px)` },
    show: { transform: `translateX(${drawerOpenWidth}px)` },
}));

export const DrawerToogler = () => {
    const { classes, cx } = useStyles();
    const drawer = useDrawerContext();
    const { t } = useTranslation(["common"]);

    const onClick = () =>
        drawer.setOpen((prev) => {
            UserSettingsService.setCommonValue("drawerOpen", !prev);
            return !prev;
        });

    return (
        <button
            className={cx(classes.toggleButton, drawer.open ? classes.show : classes.hide)}
            onClick={onClick}
            aria-label={t(drawer.open ? "common:tooltip.closeMenu" : "common:tooltip.openMenu")}
            aria-expanded={drawer.open}
        >
            <i className={cx(`fa-solid fa-angle-${drawer.open ? "left" : "right"}`, classes.toggleIcon)} />
        </button>
    );
};
